var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';
import { connect } from 'react-redux';
import Transparencia from './components/transparencia';
import Lienzo from './components/lienzo';
import { getColorLapiz, getGrosorLapiz, getColorMarcador, getGrosorMarcador, getAlphaMarcador, getGrosorBorrador, getHerramienta, getDataURL, getEditorActivo } from './selectors';

var Pizarra = function Pizarra(_ref) {
  var visible = _ref.visible,
      resolucion = _ref.resolucion,
      editorActivo = _ref.editorActivo,
      propsLienzo = _ref.propsLienzo,
      dataURL = _ref.dataURL,
      style = _ref.style;

  if (!visible) {
    return false;
  }

  if (editorActivo) {
    return React.createElement(Lienzo, _extends({}, propsLienzo, {
      dataURL: dataURL,
      resolucion: resolucion,
      style: style
    }));
  }

  return React.createElement(Transparencia, {
    dataURL: dataURL,
    style: style
  });
};

Pizarra.propTypes = process.env.NODE_ENV !== "production" ? {
  visible: t.bool,
  resolucion: t.object,
  editorActivo: t.bool,
  propsLienzo: t.object,
  dataURL: t.string,
  style: t.object
} : {};
Pizarra = connect(function (state, ownProps) {
  return {
    editorActivo: getEditorActivo(state),
    propsLienzo: {
      colorLapiz: getColorLapiz(state),
      grosorLapiz: getGrosorLapiz(state),
      colorMarcador: getColorMarcador(state),
      grosorMarcador: getGrosorMarcador(state),
      alphaMarcador: getAlphaMarcador(state),
      grosorBorrador: getGrosorBorrador(state),
      herramienta: getHerramienta(state)
    },
    dataURL: getDataURL(state)
  };
})(Pizarra);
export default Pizarra;